import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHackerearthComponent } from './simple-icons-hackerearth.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHackerearthComponent ],
    exports:      [ SimpleIconsHackerearthComponent ],
    bootstrap:    []
})
export class SimpleIconsHackerearthModule {}
